import {
  InputWithIconButton,
  InputIconButton,
  Input,
  CrossMarkIcon,
  MagnifyingGlassIcon,
  IconButton,
} from "@tandemdiabetes/sugarmate-react-components"
import classNames from "classnames"
import type {
  ChangeEventHandler,
  MouseEventHandler,
  KeyboardEventHandler,
} from "react"
import { useCallback } from "react"
import styles from "./FoodSearchInput.module.scss"

interface Props {
  textValue: string;
  hideSearchIconButton: boolean;
  setTextValue: (s: string) => void;
  setSearchValue: (s: string) => void;
}

/*
 * this component renders the text input where the user types the search term
 */
export function FoodSearchInput(props: Props) {
  const {
    textValue,
    setTextValue,
    setSearchValue,
    hideSearchIconButton,
  } = props

  const onTextChange: ChangeEventHandler<HTMLInputElement> = useCallback(
    (e) => {
      setTextValue(e.target.value)
    },
    [setTextValue],
  )

  const onSearchEnter: KeyboardEventHandler<HTMLInputElement> = useCallback(
    (e) => {
      if (e.key === "Enter" && textValue !== "") {
        setSearchValue(textValue)
      }
    },
    [
      textValue,
      setSearchValue,
    ],
  )

  const onSearchClick: MouseEventHandler<HTMLButtonElement> =
    useCallback(
      () => {
        setSearchValue(textValue)
      },
      [
        textValue,
        setSearchValue,
      ],
    )

  const clearInput: MouseEventHandler<HTMLButtonElement> = useCallback(
    () => {
      setTextValue("")
    },
    [setTextValue],
  )

  const clearButtonClassName = classNames({
    [styles.hiddenClearButton]: !textValue,
  })

  return (
    <div className={styles.row}>
      <InputWithIconButton className={styles.input}>
        <Input
          value={textValue}
          onChange={onTextChange}
          onKeyPress={onSearchEnter}
        />
        <InputIconButton
          className={clearButtonClassName}
          placementPreset="end"
          onClick={clearInput}
        >
          <CrossMarkIcon />
        </InputIconButton>
      </InputWithIconButton>
      {!hideSearchIconButton && (
        <IconButton
          disabled={!textValue}
          onClick={onSearchClick}
        >
          <MagnifyingGlassIcon />
        </IconButton>
      )}
    </div>
  )
}
